<template>
  <v-card flat>
    <v-col cols="12" class="px-0">
      <v-btn color="primary" icon @click="beforeLeave">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="text-h6 mr-2" style="vertical-align: middle">
        {{ $t('message.pages.video.saveProgress') }}
      </span>
    </v-col>

    <v-row no-gutters class="py-0 px-2">
      <span>
        {{ $t('message.pages.video.saveProgressMessage') }}
      </span>
      <v-col cols="12" class="mt-2">
        <v-row>
          <v-col cols="12">
            <v-switch
              class="mt-2"
              v-model="saveProgress"
              :label="$t('message.pages.video.saveWhereLeftOf')"
              @click="changePlayer({ isToForce: true })"
              hide-details
              :disabled="!hasEditVideoPerm"
            ></v-switch>
          </v-col>
          <v-col cols="12">
            <v-tooltip bottom :disabled="saveProgress">
              <template v-slot:activator="{ on }">
                <div v-on="on" class="d-inline-block">
                  <v-switch
                    class="mt-0"
                    v-model="saveProgressScreen"
                    :label="$t('message.pages.video.showWarningScreen')"
                    :disabled="!saveProgress || !hasEditVideoPerm"
                    @click="changePlayer"
                    hide-details
                  ></v-switch>
                </div>
              </template>
              <span>{{ $t('message.pages.video.disabledSaveProgress') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>

      <v-scroll-x-transition mode="out-in" hide-in-live>
        <v-form ref="form" v-model="isFormValid" lazy-validation class="mt-5">
          <v-row v-if="saveProgressScreen">
            <v-col cols="12">
              <v-text-field
                v-model="saveProgressTitle"
                :disabled="!hasEditVideoPerm"
                placeholder="Título"
                outlined
                :rules="textfieldRules"
                @blur="changePlayer"
                color="primary"
                :label="
                  $t('message.pages.video.titleInputsResumePlay.titleLabel')
                "
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="saveProgressButton1Title"
                :disabled="!hasEditVideoPerm"
                placeholder="Botão Play"
                outlined
                :rules="textfieldRules"
                @blur="changePlayer"
                color="primary"
                :label="
                  $t(
                    'message.pages.video.titleInputsResumePlay.playButtonLabel'
                  )
                "
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="saveProgressButton2Title"
                placeholder="Botão recomeçar"
                outlined
                :disabled="!hasEditVideoPerm"
                :rules="textfieldRules"
                @blur="changePlayer"
                color="primary"
                :label="
                  $t(
                    'message.pages.video.titleInputsResumePlay.restartButtonLabel'
                  )
                "
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="mt-6 pt-4 range-slider-saveProgress">
              <v-slider
                v-model="saveProgressBackgroundOpacityFormated"
                :disabled="!hasEditVideoPerm"
                :label="$t('message.pages.video.titleInputsResumePlay.opacity')"
                thumb-color="primary"
                thumb-label="always"
                :min="1"
                @change="changePlayer"
              >
                <template v-slot:thumb-label>
                  {{ saveProgressBackgroundOpacityFormated }}%
                </template>
              </v-slider>
            </v-col>
          </v-row>
        </v-form>
      </v-scroll-x-transition>
    </v-row>

    <span
      v-if="internalError"
      class="red--text caption align-text ml-2 mt-2 d-block"
    >
      <v-icon color="red" size="16" class="mt-n1"> mdi-alert-circle </v-icon>
      {{ $t('message.pages.video.errors.addSaveProgress') }}
    </span>

    <v-row no-gutters class="pt-6" v-if="hasEditVideoPerm">
      <v-col cols="12">
        <v-card-actions class="px-0 pt-4 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2 px-4"
            text
            :disabled="loadingButtonSave || withoutChanges"
            @click="handleUndoChanges"
          >
            {{ $t('message.pages.video.discardChanges') }}
          </v-btn>
          <v-btn
            color="primary"
            class="px-6"
            :disabled="loadingButtonSave"
            :loading="loadingButtonSave"
            @click="handleUpdateSaveProgress"
          >
            {{ $t('message.pages.video.save') }}
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
    <unsaved-changes-modal />
  </v-card>
</template>

<script>
import UnsavedChangesModal from '../../../components/UnsavedChangesModal.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import i18n from '@/translations/lang'
import _ from 'lodash'

export default {
  name: 'VideoPlayerSaveProgress',
  components: {
    UnsavedChangesModal,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    liveVideoId: {
      required: false,
    },
  },
  data: () => ({
    videoId: '',
    loadingButtonSave: false,
    profileId: null,
    profileConfig: {},
    initialConfig: {},
    saveProgress: false,
    saveProgressScreen: false,
    saveProgressTitle: i18n.t(
      'message.pages.video.titleInputsResumePlay.titlePlaceholder'
    ),
    saveProgressBackgroundOpacity: 0,
    saveProgressBackgroundOpacityFormated: 0,
    saveProgressButton1Title: i18n.t(
      'message.pages.video.titleInputsResumePlay.playButtonPlaceholder'
    ),
    saveProgressButton2Title: i18n.t(
      'message.pages.video.titleInputsResumePlay.restartButtonPlaceholder'
    ),
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 40) || i18n.t('message.maximumLengthConfigs'),
      maxLengthTitle: (v) =>
        (v && v.length <= 100) || i18n.t('message.maximumLengthConfigTitle'),
      minLength: (v) => (v && v.length >= 3) || i18n.t('message.minimumLength'),
    },
    textfieldRules: [],
    withoutChanges: true,
    isFormValid: true,
  }),
  async mounted() {
    this.videoId = this.liveVideoId ? this.liveVideoId : this.$route.params.id
    this.profileId = this.$store.state.video.video.config?.profile
    this.profileConfig = this.$store.state.video.profile?.saveProgress
    this.saveProgress =
      this.$store.state.video.profile?.saveProgress.saveProgress
    this.saveProgressScreen =
      this.$store.state.video.profile?.saveProgress.saveProgressScreen
    this.saveProgressTitle =
      this.$store.state.video.profile?.saveProgress.saveProgressTitle
    this.saveProgressBackgroundOpacity =
      this.$store.state.video.profile?.saveProgress.saveProgressBackgroundOpacity
    this.saveProgressButton1Title =
      this.$store.state.video.profile?.saveProgress.saveProgressButton1Title
    this.saveProgressButton2Title =
      this.$store.state.video.profile?.saveProgress.saveProgressButton2Title
    this.saveProgressBackgroundOpacityFormated =
      this.$store.state.video.profile?.saveProgress.saveProgressBackgroundOpacityFormated
    this.initialConfig = _.cloneDeep(
      this.$store.state.video.profile?.saveProgress
    )
    this.$root.$on('discardChanges', () => {
      this.handleUndoChanges()
      this.handleBack()
    })
  },
  computed: {
    ...mapState({
      profile: (state) => state.video.profile,
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
    }),
    hasEditVideoPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-video') ?? false
      )
    },
  },
  watch: {
    saveProgressScreen: function () {
      if (!this.saveProgressScreen) {
        this.saveProgressTitle = _.cloneDeep(
          this.initialConfig.saveProgressTitle
        )
        this.saveProgressBackgroundOpacity = _.cloneDeep(
          this.initialConfig.saveProgressBackgroundOpacity
        )
        this.saveProgressBackgroundOpacityFormated = _.cloneDeep(
          this.initialConfig.saveProgressBackgroundOpacityFormated
        )
        this.saveProgressButton1Title = _.cloneDeep(
          this.initialConfig.saveProgressButton1Title
        )
        this.saveProgressButton2Title = _.cloneDeep(
          this.initialConfig.saveProgressButton2Title
        )
        this.changePlayer()
      }
    },
    '$store.state.video.profile': {
      handler() {
        this.withoutChanges = this.checkChanges()
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('video', [
      'updateProfile',

      'createProfile',

      'setProfileToVideos',
    ]),
    ...mapMutations('video', [
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_VIDEO_PROFILE_ID',
      'UPDATE_STATUS_ERROR',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async validateForm() {
      this.textfieldRules = [
        this.rules.required,
        this.rules.maxLength,
        this.rules.minLength,
      ]
      await this.$refs.form.validate()
    },
    async handleUpdateSaveProgress() {
      await this.validateForm()

      if (!this.isFormValid) return

      this.loadingButtonSave = true
      const saveProgress = {
        saveProgress: this.profile.saveProgress?.saveProgress
          ? this.profile.saveProgress?.saveProgress
          : false,
        saveProgressScreen: this.profile.saveProgress?.saveProgressScreen
          ? this.profile.saveProgress?.saveProgressScreen
          : false,
        saveProgressTitle: this.profile.saveProgress?.saveProgressTitle
          ? this.profile.saveProgress?.saveProgressTitle
          : '',
        saveProgressBackgroundOpacity:
          parseInt(
            this.profile.saveProgress?.saveProgressBackgroundOpacityFormated
          ) / 100,
        saveProgressButton1Title: this.profile.saveProgress
          ?.saveProgressButton1Title
          ? this.profile.saveProgress?.saveProgressButton1Title
          : '',
        saveProgressButton2Title: this.profile.saveProgress
          ?.saveProgressButton2Title
          ? this.profile.saveProgress?.saveProgressButton2Title
          : '',
      }
      if (
        this.saveProgressTitle.length < 3 ||
        this.saveProgressButton1Title.length < 3 ||
        this.saveProgressButton2Title.length < 3 ||
        this.saveProgressTitle.length > 100 ||
        this.saveProgressButton1Title.length > 30 ||
        this.saveProgressButton2Title.length > 30
      ) {
        this.loadingButtonSave = false
        return
      }
      if (!this.video.config.profile) {
        await this.createProfile(this.videoId)
        this.video.config.profile = this.profile_id
        this.profileId = this.profile_id
        await this.setProfileToVideos([this.profileId, this.videoId])
      }
      delete saveProgress.saveProgressBackgroundOpacityFormated
      const controls = this.$store.state.video.profile.controls
      const colors = this.$store.state.video.profile.colors
      try {
        await this.updateProfile([
          this.profileId,
          {
            saveProgress: saveProgress,
            controls: controls,
            colors: colors,
          },
        ])
        this.profile.saveProgress['saveProgressBackgroundOpacityFormated'] =
          this.profile.saveProgress?.saveProgressBackgroundOpacity * 100
        this.internalError
          ? ''
          : ((this.initialConfig = _.cloneDeep(this.profile.saveProgress)),
            this.handleSnackbar(this.$t('message.pages.video.changesSaved')),
            (this.withoutChanges = true))
        this.loadingButtonSave = false
      } catch (e) {
        console.error(e)
        this.loadingButtonSave = false
      }
    },
    changePlayer({ isToForce = false } = {}) {
      this.profile.saveProgress['saveProgress'] = this.saveProgress
      this.profile.saveProgress['saveProgressScreen'] = this.saveProgressScreen

      if (isToForce) {
        this.saveProgressScreen = this.saveProgress
        this.profile.saveProgress['saveProgressScreen'] = this.saveProgress
      }

      this.profile.saveProgress['saveProgressTitle'] = this.saveProgressTitle
      this.profile.saveProgress['saveProgressBackgroundOpacity'] =
        this.saveProgressBackgroundOpacity
      this.profile.saveProgress['saveProgressBackgroundOpacityFormated'] =
        this.saveProgressBackgroundOpacityFormated
      this.profile.saveProgress['saveProgressButton1Title'] =
        this.saveProgressButton1Title
      this.profile.saveProgress['saveProgressButton2Title'] =
        this.saveProgressButton2Title

      this.UPDATE_STATUS_ERROR(false)
      this.UPDATE_VIDEO_PROFILE(this.profile)
    },
    handleUndoChanges() {
      this.saveProgress = _.cloneDeep(this.initialConfig.saveProgress)
      this.saveProgressScreen = _.cloneDeep(
        this.initialConfig.saveProgressScreen
      )
      this.saveProgressTitle = _.cloneDeep(this.initialConfig.saveProgressTitle)
      this.saveProgressBackgroundOpacity = _.cloneDeep(
        this.initialConfig.saveProgressBackgroundOpacity
      )
      this.saveProgressBackgroundOpacityFormated = _.cloneDeep(
        this.initialConfig.saveProgressBackgroundOpacityFormated
      )
      this.saveProgressButton1Title = _.cloneDeep(
        this.initialConfig.saveProgressButton1Title
      )
      this.saveProgressButton2Title = _.cloneDeep(
        this.initialConfig.saveProgressButton2Title
      )
      this.changePlayer()
    },
    checkChanges() {
      return _.isEqual(this.profile.saveProgress, this.initialConfig)
    },
    beforeLeave() {
      if (!this.checkChanges()) {
        this.$root.$emit('unsavedChangesModal')
      } else {
        this.UPDATE_STATUS_ERROR(false)
        this.handleBack()
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
  },
}
</script>

<style>
.range-slider-saveProgress .v-slider__thumb-label {
  height: 40px !important;
  width: 40px !important;
}
</style>
